import { TranslateService } from '@ngx-translate/core';
import { EMPTY, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { AssessmentCategoryEnums } from '@pt/pt-models';

@Injectable({
  providedIn: 'root'
})
export class EnumTransformService {
  constructor(private translateService: TranslateService) {
  }

  toAdverbWithoutLabels = (value: string): Observable<string> => {
    switch (value) {
      case '(Select All)':
      case '(Seleziona tutto)':
        return this.translateService.stream('LABELS.SELECT_ALL');
      default :
        return value ?
          of(value) :
          EMPTY
    }
  };

  toAdverb = (value: string): Observable<string> => {
    switch (value) {
      case '(Select All)':
      case '(Seleziona tutto)':
        return this.translateService.stream('LABELS.SELECT_ALL');
      case null:
        return this.translateService.stream('LABELS.NONE');
      default :
        return value ?
          this.translateService.stream('LABELS.' + value) :
          EMPTY;
    }
  };


  appAssessmentCategoryToBoolean = (assessmentCategory: 'PRIMATOO' | 'SUPPLIER' | 'INTERNAL'): boolean => {
    return assessmentCategory === AssessmentCategoryEnums.PRIMATOO;
  };
}
